import { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-opportunity';
import type { RiskGapResource } from '@ctw/shared/api/snowflake/risk-gaps';
import { usePatientContext } from '@ctw/shared/context/patient-provider';
import { usePatientQuery } from '@ctw/shared/context/patient-provider';
import { getStandaloneBaseUrl } from '@ctw/shared/utils/environments';
import { QUERY_KEY_PATIENT_RISK_GAPS } from '@ctw/shared/utils/query-keys';

type JSONApiRiskGap = {
  type: 'risk-gap';
  id: string;
  attributes: RiskGapResource;
};

type JSONApiResponse<T, I = unknown> = {
  data?: Array<T>;
  included?: Array<I>;
  links?: { self: string; prev?: string; next?: string };
  errors?: Array<{ status: string; title: string; detail: string }>;
};

export const usePatientRisks = () => {
  const { patient } = usePatientContext();

  return usePatientQuery({
    queryId: QUERY_KEY_PATIENT_RISK_GAPS,
    queryFn: async ({ requestContext, ctwFetch }): Promise<Array<RiskGapModel>> => {
      const { data = {} } = await ctwFetch<JSONApiResponse<JSONApiRiskGap>>(
        `${getStandaloneBaseUrl(requestContext.env)}/api/risk-gaps?upid=${patient.UPID}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${requestContext.authToken}`,
            'zus-account': requestContext.builderId,
          },
        },
      );

      return (
        data.data?.map((resource: JSONApiRiskGap) => new RiskGapModel(resource.attributes)) ?? []
      );
    },
    enabled: Boolean(patient.UPID),
  });
};
